var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ submitting: _vm.isFormSubmitting }},[_c('div',{attrs:{"id":"paypal-button-container"}})])}
var staticRenderFns = []

export { render, staticRenderFns }